import { AddFieldDef } from "../utils/AddFieldDef";
import { appstr } from "../utils/appstr";
import {
  enumObjectTypes,
  enumOverrideType,
  kDivisionID,
  kLocationID,
  kNameID,
  kParentPositionID,
  kPersonID,
  kPositionDivisionID,
  kPositionID,
  kPositionLocation,
  kPositionTitleID,
  kReservedFieldNames,
  kSupervisorID,
  kTitleID,
  objTypeClassMap
} from "../constants";
import { QAlert } from "./QAlert";
import { QObjDBClass } from "./QObjDBClass";
import { QObjDBObject } from "./QObjDBObject";
import { QRecordLookupRFC } from "./QRecordLookupRFC";
import { QTableChange } from "./QTableChange";
import { QUpdateTableRFC } from "./QUpdateTableRFC";
import { SerializeOverrideObj } from "../utils/SerializeOverrideObj";
import { Globals } from "./Globals";

export class QTableManager {
  constructor() {
    this.fWSMgr = null;
    this.fTableInfo = null;
    this.fTableDuplicates = null;
    this.fRootDBObj = null;
  }

  InitTableManager(wsMgr, table, overrides, containsDupes) {
    this.fWSMgr = wsMgr;
    this.fTableInfo = table;
    this.fTableDuplicates = containsDupes != null ? containsDupes : false;
    if (table == null && overrides == null) return;
    var doc = wsMgr.GetDoc();
    var objDB = doc.GetObjDB();
    var overrideClass = new QObjDBClass();
    overrideClass.InitClassLightweight("Override", objDB);
    AddFieldDef(overrideClass, "chartRefObj", "chartRefObj", "chartRefObj", true);

    overrideClass.GetExistingBoxOverride = dbObj => {
      return this.GetExistingBoxOverride(dbObj);
    };

    objDB.AddClass(overrideClass);
    this.fTrackList = overrideClass.GetObjMgr();
    this.fOverrideClass = overrideClass;
    this.LoadOverrides(overrides);
  }

  GetExistingBoxOverride(dbObj) {
    var recordId = dbObj.GetObjectRecordID();
    var objType = dbObj.InferObjectType();
    var IDFieldDef = this.fOverrideClass.GetFieldDefByName("RefID");
    var overrideObjFieldDef = this.fOverrideClass.GetFieldDefByID("objType");

    var overrideList = this.fOverrides || [];
    for (var i = 0; i < overrideList.length; i++) {
      var override = overrideList[i];
      var overrideRecordId = override.GetFieldValue(IDFieldDef);
      var overrideObjType = override.GetFieldValue(overrideObjFieldDef) || enumObjectTypes.holder;

      if (overrideRecordId === recordId && overrideObjType === objType) {
        return override;
      }
    }
    return null;
  }

  OverrideHasConflicts() {
    return false;
  }

  GetDoc() {
    //TODO: This is weird scope for this fxn
    var theDoc = this.fWSMgr.GetDoc();
    return theDoc;
  }

  SendUpdate(overrideObj, onlyComment, doTalent, revertAll) {
    var wsMgr = this.fWSMgr;
    var accountName = wsMgr.GetAccountName();
    var user = wsMgr.GetUserName();
    var appendTableID = this.fTableInfo["ID"];

    return new Promise((resolve, reject) => {
      if (revertAll) {
        var override_id = overrideObj.SmartGetFieldValue("override_id");
        var data = { ID: appendTableID, override_id: override_id };
        var mode = "removeappendentry";

        var overrideRFC = new QUpdateTableRFC();
        overrideRFC.InitUpdateTables({
          fWSMgr: wsMgr,
          fTableMgr: this,
          HandleSendUpdateResponse: response => {
            resolve(response);
          }
        });
        overrideRFC.SetParams(accountName, user, mode, JSON.stringify(data));
        Globals._rfcMgr.QueueRFC(overrideRFC);
      } else {
        var overrideData = SerializeOverrideObj(overrideObj);
        var mode = "newappendentry";
        var data = { ID: appendTableID, override: overrideData };

        var overrideRFC = new QUpdateTableRFC();
        overrideRFC.InitUpdateTables({
          fWSMgr: wsMgr,
          fTableMgr: this,
          HandleSendUpdateResponse: response => {
            resolve(response);
          }
        });
        overrideRFC.SetParams(accountName, user, mode, JSON.stringify(data));
        Globals._rfcMgr.QueueRFC(overrideRFC);
      }
    });
  }

  LocateExistingDBObj(recordData, objType = enumObjectTypes.holder) {
    var dataObj = null;
    var doc = this.fWSMgr.GetDoc();
    var objDB = doc.GetObjDB();
    var targetClass = objDB.GetClassByName(objTypeClassMap[objType]);
    if (!targetClass) return dataObj;

    var recordIDDef = this.GetRecordIDFieldDef(targetClass);
    var idKey = recordIDDef.GetFieldName();
    var existingID = recordData[idKey];

    var existingDBObj = targetClass.FindObject(recordIDDef, existingID, true);
    if (existingDBObj) {
      dataObj = existingDBObj;
    }
    return { dataObj: dataObj, recordData: recordData, idKey: idKey };
  }

  GetBoxClass() {
    var overrideClass = this.fOverrideClass;
    var objDB = overrideClass.GetObjDB();
    var boxClass = objDB.GetClassByName("Box");

    return boxClass;
  }

  GetRecordIDFieldDef(boxClass) {
    return (boxClass || this.GetBoxClass()).GetRecordIDFieldDef();
  }

  GetTitleFieldDef(boxClass) {
    return (boxClass || this.GetBoxClass()).GetTitleFieldDef();
  }

  lastActiveChange(theOverride) {
    if (!theOverride) return null;
    return theOverride.fChanges[0]; // not actual override objs
  }

  lastActiveChangedField(theOverride, field, getPrevious) {
    if (!theOverride || getPrevious)
      // return null
      return null;
    var changeHistory = theOverride.fChanges;
    for (var j = changeHistory.length - 1; j >= 0; j--) {
      var mostRecentChange = changeHistory[j];
      if (mostRecentChange.fDelta == null) return null;
      var deltaKeys = Object.keys(mostRecentChange.fDelta);
      if (deltaKeys.includes(field)) {
        return mostRecentChange;
      }
    }
    return null;
  }

  CloneDeltas(theOverride) {
    if (!theOverride) return null;
    var changeHistory = theOverride.fChanges;
    var deltaList = changeHistory.map(function (item) {
      return item.fDelta;
    });
    return JSON.parse(JSON.stringify(deltaList));
  }

  OpenOverrideEditor(overrideObj, dataObj, searchResult, changeType, objType) {
    var doc = this.fWSMgr.GetDoc();
    var objDB = doc.GetObjDB();

    if (!objType && overrideObj) {
      objType = overrideObj.SmartGetFieldValue("objType") || enumObjectTypes.holder;
    }

    if (!objType) {
      objType = enumObjectTypes.holder;
    }

    var targetClass = objDB.GetClassByName(objTypeClassMap[objType]);
    var chartRefObj = null;
    if (!this.fOverrideClass) {
      var overrideClass = new QObjDBClass();
      overrideClass.InitClassLightweight("Override", objDB);
      AddFieldDef(overrideClass, "chartRefObj", "chartRefObj", "chartRefObj", true);
      objDB.AddClass(overrideClass);
      this.fOverrideClass = overrideClass;
    }
    if (overrideObj) {
      changeType = overrideObj.SmartGetFieldValue("Type");
      chartRefObj = overrideObj.SmartGetFieldValue("chartRefObj"); // straight json obj
    } else if (changeType == null) changeType = enumOverrideType.add;

    var newDBObj = new QObjDBObject();
    newDBObj.InitObject(targetClass);
    if (dataObj && changeType !== enumOverrideType.add) {
      newDBObj = dataObj.Clone(true);
      if (!chartRefObj) {
        if (searchResult !== null) {
          chartRefObj = JSON.parse(JSON.stringify(searchResult));
        } else {
          const snapshot = {};
          const n = targetClass.GetFieldCount();
          for (var i = 0; i < n; i++) {
            var fieldDef = targetClass.GetIndexFieldDef(i);
            var val = newDBObj.GetFieldValue(fieldDef, false);
            if (val != null && val !== "") snapshot[fieldDef.GetFieldName()] = val;
          }
          if (Object.keys(snapshot).length > 0) chartRefObj = snapshot;
        }
      }
    } else {
      //apply search data or chart data obj reference from override
      if (searchResult !== null) {
        for (var aSearchKey in searchResult) {
          var searchValue = searchResult[aSearchKey];
          var fieldDef = targetClass.GetFieldDefByName(aSearchKey);
          if (!fieldDef) continue;
          newDBObj.SetFieldValue(fieldDef, searchValue);
        }
        if (!chartRefObj) chartRefObj = JSON.parse(JSON.stringify(searchResult));
      } else {
        const defaultFields =
          objType === enumObjectTypes.position
            ? [
                kPositionID,
                kPositionTitleID,
                kParentPositionID,
                kPositionLocation,
                kPositionDivisionID
              ]
            : [kPersonID, kNameID, kTitleID, kLocationID, kDivisionID, kSupervisorID];

        defaultFields.forEach(fieldId => newDBObj.SmartSetFieldValue(fieldId, ""));
      }
    }
    var sourceBase = null;
    if (changeType !== enumOverrideType.add) {
      sourceBase = dataObj ? dataObj.Clone(true) : newDBObj.Clone(true);
    }

    //apply changes
    if (overrideObj != null && changeType !== enumOverrideType.delete) {
      var changeObj = this.lastActiveChange(overrideObj);
      var changeData = changeObj.fDelta;
      for (var fieldIdx in changeData) {
        var searchValue = changeData[fieldIdx];
        var fieldDef = targetClass.GetFieldDefByName(fieldIdx);
        if (!fieldDef) continue;
        newDBObj.SetFieldValue(fieldDef, searchValue);
      }
    }

    if (sourceBase) newDBObj.fCloneBase = sourceBase;

    if (overrideObj == null) {
      const objType = newDBObj.InferObjectType();
      overrideObj = this.CreateOverride(
        changeType,
        objType,
        newDBObj.GetObjectRecordID(),
        "",
        [],
        undefined,
        chartRefObj
      );
    } else if (chartRefObj && !overrideObj.SmartGetFieldValue("chartRefObj")) {
      overrideObj.SmartSetFieldValue("chartRefObj", chartRefObj);
    }

    return { newDBObj, overrideObj, chartRefObj };
  }

  CreateOverride(changeType, objType, id, comment, changes, override_id, chartRefObj) {
    var overrideClass = this.fOverrideClass;
    var newObj = new QObjDBObject();
    newObj.InitObject(overrideClass);
    newObj.InitNewObject(overrideClass);
    newObj.SmartSetFieldValue("Type", changeType);
    newObj.SmartSetFieldValue("RefID", id);
    newObj.SmartSetFieldValue("override_id", override_id);
    newObj.SmartSetFieldValue("chartRefObj", chartRefObj);
    newObj.SmartSetFieldValue("objType", objType);

    var theComment = comment;
    if (theComment) {
      var commentDef = overrideClass.GetFieldDefByID("Comment");
      newObj.AddNewFieldValue(commentDef, theComment);
    }
    var changeList = changes;
    newObj.fChanges = [];
    if (!changeList) changeList = [];
    for (var j = 0; j < changeList.length; j++) {
      var theChange = changeList[j];
      var newChange = new QTableChange();
      newChange.InitChange(this.fWSMgr, theChange, newObj, null, overrideClass);
      newObj.fChanges.push(newChange);
    }
    return newObj;
  }

  LoadRecords(idList, resolve, handlePositions = false) {
    var w = this.fWSMgr;
    var isLoadingPositions = "positionIDs" in idList;
    var recordIDs = idList["recordIDs"] || idList["positionIDs"];

    var callbackObj = {
      SvrQueryResult: (success, data) => {
        if (success && isLoadingPositions && data && data.length > 0) {
          var doc = w.GetDoc();
          var objDB = doc.GetObjDB();
          var boxClass = objDB.GetClassByName("Box");
          var positionData = data[0];
          var holdersData = positionData.__HOLDERS__ || [];
          var positionId = positionData[doc.GetPositionIDKey?.() || "PositionID"];

          var holders = [];
          for (var i = 0; i < holdersData.length; i++) {
            const holderDBObj = new QObjDBObject();
            holderDBObj.InitObject(boxClass);
            boxClass.ProcessObject(holderDBObj, holdersData[i]);

            var override = this.GetExistingBoxOverride?.(holderDBObj);
            if (override) {
              override.ApplyChangesReadOnly(holderDBObj);
            }

            holders.push(holderDBObj);
          }

          if (holders.length > 0) {
            w.BroadcastTopic("positionLoadedWithHolders", {
              positionId: positionId,
              holders: holders
            });
          }
        }

        if (!isLoadingPositions) {
          data = { data: data || [] };
        } else {
          data = { positions: data || [] };
        }

        if (resolve) {
          resolve(data);
        }
      }
    };

    var recordLookup = new QRecordLookupRFC();
    recordLookup.InitRecordLookup(callbackObj);
    recordLookup.SetParams(
      w.GetAccountName(),
      recordIDs,
      w.GetDoc()?.GetChartID(),
      w.GetUserName(),
      isLoadingPositions ? true : handlePositions
    );
    Globals._rfcMgr.QueueRFC(recordLookup);
  }

  SanitizeRecord(
    jsonRec // records returned from this type of search are forcing id's to be returned
  ) {
    var doc = this.fWSMgr.GetDoc();
    var includeFieldIds = ["Division", "Location"];
    var fieldMap = doc.GetFieldMap(includeFieldIds);
    for (var i in jsonRec) {
      if (i in fieldMap) {
        jsonRec[fieldMap[i]] = jsonRec[i];
      }
    }
    return jsonRec;
  }

  LoadOverrides(overrides) {
    this.fOverrides = [];
    for (var i = 0; i < overrides.length; i++) {
      var theOverride = overrides[i];
      var changeType = theOverride["type"];
      var objectType = theOverride["objType"] ?? enumObjectTypes.holder;
      var id = theOverride["id"];
      var override_id = theOverride["override_id"];
      var comment = theOverride["comment"];
      var changes = theOverride["changes"];
      var tableRefObj = theOverride["chartRefObj"];
      var overrideObj = this.CreateOverride(
        changeType,
        objectType,
        id,
        comment,
        changes,
        override_id,
        tableRefObj
      );
      this.fOverrides.push(overrideObj);
    }
  }

  GetNumOverrides() {
    return this.fOverrides.length;
  }

  GetAvailableChartFields(currentChartConfig) {
    var fieldMap = currentChartConfig["fields"];
    var reservedFieldNames = Object.values(fieldMap);
    var targetHeaders = currentChartConfig["headers"];
    var excludeFields = reservedFieldNames.concat(kReservedFieldNames);
    return targetHeaders
      .filter(function (aHeader) {
        return excludeFields.indexOf(aHeader) < 0;
      })
      .sort();
  }

  GetManualAddedFields(currentChartConfig) {
    var manualFields = this.fTableInfo?.["additionalFields"] || [];
    if (!manualFields.length) return [];

    var targetHeaders = currentChartConfig["headers"] || [];
    // Return only manual fields that don't already exist as chart headers
    return manualFields.filter(function (field) {
      return targetHeaders.indexOf(field) < 0;
    });
  }

  IsValidOverride(changes, newOverride, refID) {
    if (refID == null || refID == "") {
      var noIDAlert = new QAlert();
      noIDAlert.InitAlert(appstr("Alert"), appstr("buildhier1"), null, this.fWSMgr);
      return false;
    }

    if (newOverride.SmartGetFieldValue("RefID") === refID) return true;

    if (newOverride.fFieldValues[3].fFieldValue != null) return true;
    var existingOverrides = this.fOverrides;
    var existingAdds = existingOverrides.filter(
      person => person.SmartGetFieldValue("RefID") == refID
    );
    var numConflicts = existingAdds.length;
    if (numConflicts) {
      var existingAddAlert = new QAlert();
      existingAddAlert.InitAlert(appstr("Alert"), appstr("personidinuse"), null, this.fWSMgr);
      return false;
    }
    return true;
  }

  GetChangesOfType(type) {
    return this.fOverrides.filter(function (a) {
      return a.SmartGetFieldValue("Type") == type;
    });
  }

  GetManagerName() {
    return "tableManager";
  }
}
